import wretch from 'wretch';
import QueryStringAddon from 'wretch/addons/queryString';
import AbortAddon from 'wretch/addons/abort';
import { PersonDataSchema, AbortError } from '@fe-learner-common';
import { localizedErrorHandlers } from '@fe-core/api';
import * as v from 'valibot';

const ParticipantsDataSchema = v.object({
  participants: v.array(PersonDataSchema),
  total: v.number(),
});

const ParticipantsPayloadSchema = v.object({
  payload: ParticipantsDataSchema,
});

export type TParticipantsData = v.Output<typeof ParticipantsDataSchema>;

export type TParticipantsParams = {
  pageIndex: number;
  pageSize?: number | null;
  sort: string;
};

export const getParticipants = async (
  baseUrl: string,
  participationId: string,
  params?: TParticipantsParams,
  signal?: AbortSignal,
): Promise<TParticipantsData> => {
  const controller = new AbortController();

  const url = `${baseUrl}api/v2/participation/${participationId}/participants`;
  const instance = wretch(url, {
    credentials: 'include',
  })
    .addon(AbortAddon())
    .signal(controller)
    .addon(QueryStringAddon)
    .query(params || {})
    .get()
    .onAbort(() => {
      throw new AbortError();
    });

  signal?.addEventListener('abort', () => {
    controller.abort();
  });

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(ParticipantsPayloadSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output.payload;
    } else {
      console.error(
        'fe-learner-common | getParticipants | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid participants response');
    }
  });
};
